import React, {Component} from 'react';
import './style.scss';

export class AssetsCreditRiskTable extends Component {
  render() {
    const data = [
      {
        index: 'I',
        name: 'Tài sản có rủi ro tín dụng',
        isPrimaryRow: true,
      },
      {
        index: '1',
        name: 'Treasury',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản phải đòi quốc gia',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản phải đòi ngân hàng',
        isPrimaryRow: false,
      },

      {
        index: '2',
        name: 'Khối KHDN',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi doanh nghiệp - SME',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi doanh nghiệp - DN khác',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Mua lại khoản phải đòi doanh nghiệp',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản cấp tín dụng chuyên biệt',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản vỡ nợ',
        isPrimaryRow: false,
      },

      {
        index: '3',
        name: 'Khối KHCN',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản cho vay thế chấp nhà',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi bán lẻ quay vòng',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi bán lẻ khác',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Mua lại khoản phải thu bán lẻ',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản vỡ nợ',
        isPrimaryRow: false,
      },

      {
        index: '4',
        name: 'Khối',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Công cụ vốn chủ sở hữu',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Tài sản khác',
        isPrimaryRow: false,
      },

      {
        index: 'II',
        name: 'Mức độ bao phủ IRB (RWA) ((2)+(3)',
        isPrimaryRow: true,
      },
      {
        index: 'III',
        name: 'Mức độ bao phủ theo yêu cầu',
        isPrimaryRow: true,
      },
    ];
    return (
      <div>
        <table className='table table-hover table-striped AssetsCreditRiskTable'>
          <thead>
            <tr>
              <th>STT</th>
              <th style={{minWidth: 364}}>Loại tài sản</th>
              <th>
                Số dự nội bảng + ngoại bảng
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>
              <th>
                Tỷ trọng dư nợ nội bảng + ngoại bảng
                <br /> <span className='unit'>%</span>
              </th>
              <th>
                EL
                <br />
                <span className='unit'>Triệu đồng<br /> (PD x LGD x EAD)</span>
              </th>
              <th>
                Dự phòng lũy kế
                <br />
                <span className='unit'>
                  Triệu đồng
                  <br /> (Dự phòng chung + Dự phòng cụ thể)
                </span>
              </th>
              <th>
                Tài sản có rủi ro (RWA)
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>
              <th>
                Tỷ trọng RWA
                <br /> <span className='unit'>%</span>
              </th>
              <th>
                Thu nhập lãi thuần
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>
              <th>
                Thu nhập lãi thuần/RWA
                <br /> <span className='unit'>%</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.file_name} className={item.isPrimaryRow && 'primaryRow'}>
                <td>{item.index}</td>
                <td>{item.name}</td>
                <td></td>
                <td></td>
                <td></td>

                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default AssetsCreditRiskTable;



// WEBPACK FOOTER //
// src/pages/Raroc/Report/AssetsCreditRisk/AssetsCreditRiskTable.js